class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    if (facetForm) {
      // Skip input events from sort dropdowns - they're handled by global event delegation
      facetForm.addEventListener("input", (event) => {
        if (event.target.matches("select[name='sort_by']")) {
          return; // Skip - handled by global change listener
        }
        this.debouncedOnSubmit(event);
      });
    }

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

    this.setTabDefaultValue();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  setTabDefaultValue() {
    const formElement = document.querySelector(
      "form#FacetFiltersFormTabs.tab-facets input",
    );
    if (
      formElement &&
      document.querySelectorAll(
        "form#FacetFiltersFormTabs.tab-facets input:checked",
      ).length == 0
    ) {
      formElement
        .querySelector("form#FacetFiltersFormTabs.tab-facets label")
        ?.click();
    }
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const queryParams = new URLSearchParams(window.location.search);
      // Set the 'q' parameter to the input value

      // console.log(searchParams, window.location.pathname, searchParams.includes("q="), window.location.pathname.includes("collection"), queryParams.get('q'))
      if (queryParams.get("q")) {
        // Update URL with search and filter params
        searchParams = `q=${queryParams.get("q")}&options%5Bprefix%5D=last&${searchParams}`;

        // Update the browser's address bar without reloading the page
        const url = `${window.location.origin}/search?q=${queryParams.get("q")}&options%5Bprefix%5D=last&${searchParams}`;

        fetch(url)
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              throw error;
            }
            // console.log(response)
            return response.text();
          })
          .then(async (text) => {
            const resultsMarkupGrid = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".facets-container-drawer").innerHTML;
            // console.log(resultsMarkupGrid)
            document.querySelector(".facets-container-drawer").innerHTML =
              resultsMarkupGrid;

            const resultsMarkupFilter = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector("#ProductGridContainer").innerHTML;
            // console.log(resultsMarkupFilter)
            document.querySelector("#ProductGridContainer").innerHTML =
              resultsMarkupFilter;
          })
          .catch((error) => {
            throw error;
          });
      } else {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        // console.log("html",html)

        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      })
      .catch((error) => {
        console.error("FacetFiltersForm fetch error:", error);
        // Remove loading states on error
        const loadingSpinners = document.querySelectorAll(
          ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
        );
        loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
        const countContainer = document.getElementById("ProductCount");
        const countContainerDesktop = document.getElementById(
          "ProductCountDesktop",
        );
        if (countContainer) countContainer.classList.remove("loading");
        if (countContainerDesktop)
          countContainerDesktop.classList.remove("loading");
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById("ProductGridContainer");
    const parsedHtml = new DOMParser().parseFromString(html, "text/html");
    const newContainer = parsedHtml.getElementById("ProductGridContainer");

    if (container && newContainer) {
      container.innerHTML = newContainer.innerHTML;
      container.querySelectorAll(".scroll-trigger").forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });

      // Restore view preference from localStorage after AJAX re-render
      FacetFiltersForm.restoreGridView();
    }
  }

  static restoreGridView() {
    // Restore view preference from localStorage after AJAX re-render
    // Check both localStorage keys used by different view toggle implementations
    const gridView = localStorage.getItem("gridView");
    const collectionView = localStorage.getItem("collectionView");
    const isListView = gridView?.includes("list") || collectionView === "list";

    const productGridContainer = document.getElementById(
      "ProductGridContainer",
    );
    const filterGridContainer = document.querySelector(".facets-wrapper");
    const remoteFilterButton = document.querySelector("remote-filter-button");
    const tilesView = document.querySelector(".tiles-view");
    const listView = document.querySelector(".list-view");

    // Sync grid-toggle radio buttons with localStorage state
    const tilesRadios = document.querySelectorAll("[id^='radio-tiles']");
    const listRadios = document.querySelectorAll("[id^='radio-list']");

    if (isListView) {
      if (productGridContainer)
        productGridContainer.setAttribute("data-view", "list");
      if (filterGridContainer)
        filterGridContainer.setAttribute("data-view", "list");
      if (remoteFilterButton)
        remoteFilterButton.setAttribute("data-view", "list");
      // Show/hide the view containers
      if (tilesView) tilesView.style.display = "none";
      if (listView) listView.style.display = "block";
      // Sync radio buttons
      tilesRadios.forEach((radio) => (radio.checked = false));
      listRadios.forEach((radio) => (radio.checked = true));
    } else {
      if (productGridContainer)
        productGridContainer.setAttribute("data-view", "tiles");
      if (filterGridContainer)
        filterGridContainer.setAttribute("data-view", "tiles");
      if (remoteFilterButton)
        remoteFilterButton.setAttribute("data-view", "tiles");
      // Show/hide the view containers
      if (tilesView) tilesView.style.display = "block";
      if (listView) listView.style.display = "none";
      // Sync radio buttons
      tilesRadios.forEach((radio) => (radio.checked = true));
      listRadios.forEach((radio) => (radio.checked = false));
    }

    // Restore banner visibility based on brandHistory localStorage
    FacetFiltersForm.restoreBrandBanner();

    // Sync checkbox states with URL after AJAX re-render
    if (typeof window.syncCheckboxesWithUrl === "function") {
      window.syncCheckboxesWithUrl();
    }

    // Re-attach checkbox listeners for filters after AJAX re-render
    if (typeof window.attachCheckboxListeners === "function") {
      window.attachCheckboxListeners();
    }

    // Re-init accordion animations for filters after AJAX re-render
    if (typeof window.initFilterAccordions === "function") {
      window.initFilterAccordions();
    }
  }

  static restoreBrandBanner() {
    // Get the brand history from localStorage
    const brandHistory = JSON.parse(
      localStorage.getItem("brandHistory") || "[]",
    );
    const bannerToShow =
      brandHistory.length > 0
        ? brandHistory[brandHistory.length - 1]
        : "generic";

    // Hide all banners first
    document.querySelectorAll(".brand-banner").forEach((banner) => {
      banner.style.display = "none";
    });
    document.querySelectorAll(".brand-banner-item").forEach((item) => {
      item.style.display = "none";
    });

    // Show the correct banner
    const selectedBanners = document.querySelectorAll(
      `.brand-banner-${bannerToShow}`,
    );
    selectedBanners.forEach((banner) => {
      banner.style.display = "flex";
    });
    const selectedItems = document.querySelectorAll(
      `.brand-banner-item-${bannerToShow}`,
    );
    selectedItems.forEach((item) => {
      item.style.display = "";
    });
  }

  static renderProductCount(html) {
    const parsedHtml = new DOMParser().parseFromString(html, "text/html");
    const countElement = parsedHtml.getElementById("ProductCount");
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");

    if (countElement && container) {
      container.innerHTML = countElement.innerHTML;
      container.classList.remove("loading");
    }
    if (containerDesktop) {
      if (countElement) {
        containerDesktop.innerHTML = countElement.innerHTML;
      }
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id,
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element),
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId,
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.renderCustomFilterButtons(parsedHTML);

    if (countsToRender && event && event.target) {
      const closestJSFilter = event.target.closest(".js-filter");
      const closestJSFilterID = closestJSFilter ? closestJSFilter.id : null;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter"),
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID),
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        if (newFacetDetailsElement) {
          const newElementSelector = newFacetDetailsElement.classList.contains(
            "mobile-facets__details",
          )
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate =
            newFacetDetailsElement.querySelector(newElementSelector);
          if (newElementToActivate) newElementToActivate.focus();
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
      ".active-facets-wrapper",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
      "#FacetsWrapperMobile",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      if (selector == "#FacetsWrapperMobile") {
        const domElement = document.querySelector(selector);
        if (!domElement) return;
        let openAccordions = [];
        domElement.querySelectorAll("details[open]").forEach((accordion) => {
          if (accordion.id) {
            if (
              accordion.id.includes("Details-Mobile-") &&
              accordion.id.includes("--")
            ) {
              let push_id = accordion.id.split("--")[0];
              openAccordions.push(push_id);
            }
          }

          openAccordions.forEach((accordion) => {
            let accordionToOpen = html
              .querySelector(selector)
              .querySelector(`[id^='${accordion}--']`);
            if (accordionToOpen) {
              accordionToOpen.setAttribute("open", "");
            }
          });
        });
        domElement.innerHTML = html.querySelector(selector).innerHTML;
      } else {
        const domElement = document.querySelector(selector);
        const htmlElement = html.querySelector(selector);
        if (!domElement || !htmlElement) return;
        domElement.innerHTML = htmlElement.innerHTML;
        // Render Filter counts for different views
        if (selector == ".mobile-facets__open") {
          let remote_filter_button = document.querySelector(
            "remote-filter-button",
          );
          if (!remote_filter_button) return;
          const activeFacetFilters = htmlElement.querySelector(
            ".active-facet-filters",
          );
          if (activeFacetFilters) {
            remote_filter_button.querySelector(
              ".active-facet-filters",
            ).innerHTML = activeFacetFilters.innerHTML;
          }
        }
        // Sort dropdown changes are handled by global event delegation - no need to re-bind
      }
    });

    const mobileForm = document.getElementById("FacetFiltersFormMobile");
    if (mobileForm) {
      const menuDrawer = mobileForm.closest("menu-drawer");
      if (menuDrawer && typeof menuDrawer.bindEvents === "function") {
        menuDrawer.bindEvents();
      }
    }
  }

  static renderCustomFilterButtons(html) {
    const customFIlterSelectors = [
      ".tab-facets",
      ".radio-facets",
      ".image-facets",
    ];

    customFIlterSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });
  }
  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden"),
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item"),
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }
  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    let sections = [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
    return sections;
  }

  createSearchParams(form, event) {
    const clonedForm = form.cloneNode(true);
    // Synch values in clonedFrom  (clonedForm Selects have values where selected="selected" not the new values)
    form.querySelectorAll("select").forEach((select) => {
      clonedForm.querySelector(`#${select.id}`).value = select.value;
    });
    // Delete empty values and ignored values for desktop and mobile

    // TODO: Ignore Values for different viewtypes
    const isMobile = window.innerWidth < 750;
    const facetsWrapper = form.closest(".facets-wrapper");
    const currentView = facetsWrapper ? facetsWrapper.dataset.view : "tiles";

    clonedForm.querySelectorAll("input").forEach((input) => {
      if (
        input.value == "" ||
        input.value == false ||
        input.value == undefined ||
        input.value == null ||
        (input.classList.contains("ignore-mobile") && isMobile) ||
        (input.classList.contains("ignore-desktop") && !isMobile)
      ) {
        // Check for list view if input classlist is ignore desktop
        // Radio Facets can contain ignore desktop and ignore-tiles --> Dont ignore if view is list
        // ignore on tiles desktop (dont ignore on list view)
        if (
          input.classList.contains("ignore-desktop") &&
          !isMobile &&
          input.classList.contains("ignore-tiles")
        ) {
          if (currentView == "tiles") {
            input.remove();
          }
        }
        // Remove Ignored
        else {
          input.remove();
        }
      }
      // Ignore Image Checkboxes in Drawer on Tiles View
      else if (
        input.classList.contains("ignore-tiles") &&
        currentView == "tiles"
      ) {
        // if is tiles view and input has ignore-desktop and ignore-tiles dont ignore on mobile
        if (!input.classList.contains("ignore-desktop")) {
          input.remove();
        } else if (!isMobile) {
          input.remove();
        }
      } else if (
        input.classList.contains("ignore-list") &&
        currentView == "list"
      ) {
        input.remove();
      }
    });
    clonedForm.querySelectorAll("select").forEach((select) => {
      if (
        (select.classList.contains("ignore-mobile") && isMobile) ||
        (select.classList.contains("ignore-desktop") && !isMobile)
      ) {
        select.remove();
      }
    });
    const formData = new FormData(clonedForm);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    let queryString = "facet-filters-form form";
    // Select all Forms
    const sortFilterForms = document.querySelectorAll(queryString);
    const forms = [];

    // When Tab clicked remove all Filters to make it look like real Tabs
    if (event.srcElement.className == "tab-facets__checkbox") {
      const activeTab = document.querySelector(
        ".tab-facets__item.active .tab-facets__checkbox",
      );
      if (activeTab && activeTab != event.srcElement) {
        activeTab.disabled = true;
      }
      if (window.innerWidth < 750) {
        const containerElement = event.srcElement.closest(
          ".facets-container--tab-wrapper",
        );
        const targetElement = event.srcElement.closest(".tab-facets__item");
        const scrollXPosition =
          targetElement.offsetLeft - containerElement.offsetLeft;

        // Scrollt horizontal zum Ziel-Element
        containerElement.scrollTo({
          left: scrollXPosition,
          behavior: "smooth",
        });
      }
      document
        .querySelectorAll(".radio-facets__checkbox, .image-facets__checkbox")
        .forEach((checkbox) => {
          checkbox.disabled = true;
        });
      let searchParams = this.createSearchParams(
        event.target.closest("form"),
        event,
      );
      // Append old sorted param (sortParams are only created of one formular when tab facets are clicked)
      let old_url = new URL(window.location.href);
      if (old_url.searchParams.has("sort_by")) {
        searchParams =
          searchParams + "&sort_by=" + old_url.searchParams.get("sort_by");
      }
      this.onSubmitForm(searchParams, event);
    } else {
      if (event.srcElement.className == "image-facets__checkbox") {
        const activeImage = document.querySelector(
          ".image-facets__item.active .image-facets__checkbox",
        );
        if (activeImage && activeImage != event.srcElement) {
          activeImage.disabled = true;
        }
      }

      // Check if the event is from a sort-only form (FacetSortForm or FacetSortDrawerForm)
      // If so, preserve existing URL filters and just update sort_by
      const eventForm = event.target.closest("form");
      if (
        eventForm &&
        (eventForm.id === "FacetSortForm" ||
          eventForm.id === "FacetSortDrawerForm")
      ) {
        const currentUrl = new URL(window.location.href);
        const selectElement = eventForm.querySelector("select[name='sort_by']");
        if (selectElement) {
          const newSortValue = selectElement.value;
          currentUrl.searchParams.set("sort_by", newSortValue);
          // Remove section_id if present and build clean search params
          currentUrl.searchParams.delete("section_id");
          this.onSubmitForm(currentUrl.searchParams.toString(), event);
          return;
        }
      }

      // Combine searchparams for all forms when no tabs are clicked
      sortFilterForms.forEach((form) => {
        if (
          form.id === "FacetSortForm" ||
          form.id === "FacetFiltersForm" ||
          form.id === "FacetSortDrawerForm"
        ) {
          const noJsElements = document.querySelectorAll(".no-js-list");
          noJsElements.forEach((el) => el.remove());
          let searchParams = this.createSearchParams(form, event);

          if (searchParams != "" && searchParams != null) {
            forms.push(searchParams);
          }
        } else {
          let searchParams = this.createSearchParams(form, event);
          if (searchParams != "" && searchParams != null) {
            forms.push(searchParams);
          }
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

// Global event delegation for sort dropdowns - works even after AJAX re-renders
document.addEventListener("change", function (event) {
  const select = event.target;
  // Check if this is a sort dropdown (by ID or form context)
  if (
    select.matches("#SortBy, #SortBy-mobile, select[name='sort_by']") ||
    (select.closest("form") &&
      (select.closest("form").id === "FacetSortForm" ||
        select.closest("form").id === "FacetSortDrawerForm"))
  ) {
    event.preventDefault();
    const newSortValue = select.value;
    if (!newSortValue) return; // Skip if empty "Sort by" placeholder is selected

    const currentUrl = new URL(window.location.href);

    // Restore filter params from localStorage to ensure they're not lost
    const storedFilters = localStorage.getItem("activeFilters");
    if (storedFilters) {
      try {
        const filters = JSON.parse(storedFilters);

        // Brand display name mapping
        const brandDisplayNames = {
          nutriment: "Nutriment",
          purrform: "Purrform",
          dibo: "Dibo",
          aniforte: "Aniforte",
          "natural-instinct": "Natural Instinct",
        };

        // Protein display name mapping
        const proteinDisplayNames = {
          chicken: "Chicken",
          "beef-veal": "Beef & Veal",
          pork: "Pork",
          salmon: "Salmon",
          "white-fish": "White Fish",
          lamb: "Lamb",
          venison: "Venison",
          "rabbit-hare": "Rabbit & Hare",
          tripe: "Tripe",
          turkey: "Turkey",
          goose: "Goose",
          duck: "Duck",
          alpaca: "Alpaca",
          horse: "Horse",
          goat: "Goat",
          quail: "Quail & Pigeon",
        };

        // Format display name mapping
        const formatDisplayNames = {
          tray: "Tray",
          chubb: "Chubb",
          bag: "Bag",
          pouch: "Pouch",
          tube: "Tube",
          box: "Box",
          loose: "Loose",
          "supplement-jar": "Supplement Jar",
          bottle: "Bottle",
        };

        // Clear existing filter params first
        currentUrl.searchParams.delete("filter.p.m.custom.brand");
        currentUrl.searchParams.delete("filter.p.m.custom.main_protein");
        currentUrl.searchParams.delete("filter.p.m.custom.product");
        currentUrl.searchParams.delete("filter.v.price.gte");
        currentUrl.searchParams.delete("filter.v.price.lte");

        // Add brand filters
        if (filters.brands && filters.brands.length > 0) {
          filters.brands.forEach((brand) => {
            const displayName = brandDisplayNames[brand] || brand;
            currentUrl.searchParams.append(
              "filter.p.m.custom.brand",
              displayName,
            );
          });
        }

        // Add protein filters
        if (filters.proteins && filters.proteins.length > 0) {
          filters.proteins.forEach((protein) => {
            const displayName = proteinDisplayNames[protein] || protein;
            currentUrl.searchParams.append(
              "filter.p.m.custom.main_protein",
              displayName,
            );
          });
        }

        // Add format filters
        if (filters.formats && filters.formats.length > 0) {
          filters.formats.forEach((format) => {
            const displayName = formatDisplayNames[format] || format;
            currentUrl.searchParams.append(
              "filter.p.m.custom.product",
              displayName,
            );
          });
        }

        // Add price filters
        if (filters.prices && filters.prices.length > 0) {
          let minPrice = Infinity;
          let maxPrice = 0;
          filters.prices.forEach((p) => {
            if (p.min && parseFloat(p.min) < minPrice)
              minPrice = parseFloat(p.min);
            if (p.max && parseFloat(p.max) > maxPrice)
              maxPrice = parseFloat(p.max);
          });
          if (minPrice !== Infinity) {
            currentUrl.searchParams.set(
              "filter.v.price.gte",
              minPrice.toString(),
            );
          }
          if (maxPrice > 0) {
            currentUrl.searchParams.set(
              "filter.v.price.lte",
              maxPrice.toString(),
            );
          }
        }
      } catch (e) {
        console.error("Error parsing stored filters:", e);
      }
    }

    currentUrl.searchParams.set("sort_by", newSortValue);
    currentUrl.searchParams.delete("section_id");

    FacetFiltersForm.renderPage(currentUrl.searchParams.toString(), event);
  }
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = document
      .querySelector("#FacetFiltersFormMobile")
      .closest("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

class CollectionPageSearch extends FacetFiltersForm {
  constructor() {
    super();

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);
    this.querySelector("input").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this),
    );
    document.addEventListener("DOMContentLoaded", this.initPage());
  }

  onSubmitHandler(event) {
    event.preventDefault();

    // Get the input value
    const searchValue = event.target.value;

    // Create a new URLSearchParams object with the current URL query parameters
    const queryParams = new URLSearchParams(window.location.search);

    // Set the 'q' parameter to the input value
    queryParams.set("q", searchValue);
    queryParams.delete("page");

    // Construct the new URL with updated query parameters
    const newUrl = `${window.location.pathname}?q=${searchValue}&options%5Bprefix%5D=last&${queryParams.toString()}`;

    // Update the browser's address bar without reloading the page
    window.history.pushState({ path: newUrl }, "", newUrl);

    let url = window.Shopify.routes.root + `search?${queryParams}`;
    // check if search bar is empty to reload initial state
    if (searchValue == "") {
      url = "/collections/all";
    }
    this.renderProductGrid(url, true);
  }

  renderProductGrid(url, reloadFilter) {
    reloadFilter = false;
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    document.querySelector("body").classList.add("stop-scrolling");

    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then(async (text) => {
        if (reloadFilter == true) {
          const resultsMarkupFilter = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(".facets-container-drawer").innerHTML;
          document.querySelector(".facets-container-drawer").innerHTML =
            resultsMarkupFilter;
        }

        const resultsMarkupGrid = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#ProductGridContainer").innerHTML;
        document.querySelector("#ProductGridContainer").innerHTML =
          resultsMarkupGrid;

        console.log(window.location);
        if (!window.location.pathname.includes("/search")) {
          let paginationLinks = document.querySelectorAll(
            ".pagination-wrapper .pagination__item",
          );
          paginationLinks.forEach((item) => {
            if (item.href && item.href.includes("/search")) {
              item.href = item.href.replace("/search", "/collections/all");
            }
          });
        }

        document.querySelector("body").classList.remove("stop-scrolling");
      })
      .catch((error) => {
        throw error;
      });
  }
  initPage() {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get("q") && queryParams.get("page")) {
      let url = `/search?${queryParams}`;
      this.renderProductGrid(url, false);
      this.querySelector(".search__input").value = queryParams.get("q");
    }
  }
}
customElements.define("collection-page-search", CollectionPageSearch);
